import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/a11y";
import * as i2 from "@mhe/ngx-shared/translate";
import * as i3 from "@angular/common";
import * as i4 from "@mhe/ngx-shared/overlay";
function SpinnerComponent_mhe_overlay_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SpinnerComponent_mhe_overlay_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mhe-overlay", 2);
    i0.ɵɵlistener("close", function SpinnerComponent_mhe_overlay_0_Template_mhe_overlay_close_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.overlayClose()); });
    i0.ɵɵtemplate(1, SpinnerComponent_mhe_overlay_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("isTransparent", ctx_r0.hasTransparentOverlay)("isOpen", ctx_r0.isOpen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function SpinnerComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function SpinnerComponent_ng_template_1_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.close.emit()); });
    i0.ɵɵelementStart(1, "div", 6)(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "mheTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 8);
    i0.ɵɵelement(7, "circle", 9)(8, "circle", 10);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("height", ctx_r6.size, "px")("width", ctx_r6.size, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkTrapFocusAutoCapture", ctx_r6.hasTrappedFocus);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, i0.ɵɵpipeBind1(5, 8, "ngx-shared-content-is-loading")));
} }
function SpinnerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SpinnerComponent_ng_template_1_div_0_Template, 9, 10, "div", 4);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.isOpen);
} }
export class SpinnerComponent {
    constructor(liveAnnouncer, translateService) {
        this.liveAnnouncer = liveAnnouncer;
        this.translateService = translateService;
        this.hasTransparentOverlay = false;
        this.hasTrappedFocus = false;
        this.useOverlay = true;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        this._size = 50;
    }
    set size(value) {
        if (typeof value === 'number')
            this._size = value;
        else {
            const parsed = Number(value);
            if (isNaN(parsed)) {
                throw new Error(`SpinnerComponent.size must be a valid parseable number, got "${value}" instead`);
            }
            this._size = parsed;
        }
    }
    get size() {
        return this._size;
    }
    announcePageLoading() {
        this.translateService.translate('ngx-shared-please-wait-the-page-is-loading').subscribe((loading) => {
            if (!loading) {
                return;
            }
            this.liveAnnouncer.announce(loading, 'assertive');
            this.announceInterval = setInterval(() => {
                this.liveAnnouncer.announce(loading, 'assertive');
            }, 5000);
        });
    }
    ngOnChanges(changes) {
        if (changes.isOpen) {
            if (changes.isOpen.currentValue) {
                this.announcePageLoading();
            }
            else {
                this.liveAnnouncer.clear();
                clearInterval(this.announceInterval);
            }
        }
    }
    ngOnDestroy() {
        clearInterval(this.announceInterval);
    }
    overlayClose() {
        this.close.emit();
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(i0.ɵɵdirectiveInject(i1.LiveAnnouncer), i0.ɵɵdirectiveInject(i2.TranslateService)); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["mhe-spinner"]], inputs: { isOpen: "isOpen", hasTransparentOverlay: "hasTransparentOverlay", hasTrappedFocus: "hasTrappedFocus", size: "size", useOverlay: "useOverlay" }, outputs: { close: "close" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[3, "isTransparent", "isOpen", "close", 4, "ngIf", "ngIfElse"], ["spinner", ""], [3, "isTransparent", "isOpen", "close"], [4, "ngTemplateOutlet"], ["class", "ahe-ui-loading-spinner", 3, "height", "width", "click", 4, "ngIf"], [1, "ahe-ui-loading-spinner", 3, "click"], [1, "loader"], ["cdkTrapFocus", "", "tabIndex", "0", 1, "sr-only", 3, "cdkTrapFocusAutoCapture"], ["viewBox", "25 25 50 50", "focusable", "false", "aria-hidden", "true", 1, "circular"], ["cx", "50", "cy", "50", "r", "20", "fill", "none", "stroke", "white", "stroke-width", "2"], ["cx", "50", "cy", "50", "r", "20", "fill", "none", "stroke-width", "2", "stroke-miterlimit", "10", 1, "path"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SpinnerComponent_mhe_overlay_0_Template, 2, 3, "mhe-overlay", 0);
        i0.ɵɵtemplate(1, SpinnerComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.useOverlay)("ngIfElse", _r1);
    } }, dependencies: [i3.NgIf, i3.NgTemplateOutlet, i4.OverlayComponent, i1.CdkTrapFocus, i3.AsyncPipe, i2.TranslatePipe], styles: [".ahe-ui-loading-spinner[_ngcontent-%COMP%]{top:0;right:0;bottom:0;left:0;margin:auto;position:absolute}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{ selector: 'mhe-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mhe-overlay\n  *ngIf=\"useOverlay; else spinner\"\n  (close)=\"overlayClose()\"\n  [isTransparent]=\"hasTransparentOverlay\"\n  [isOpen]=\"isOpen\"\n>\n  <ng-container *ngTemplateOutlet=\"spinner\"></ng-container>\n</mhe-overlay>\n\n<ng-template #spinner>\n  <div\n    *ngIf=\"isOpen\"\n    class=\"ahe-ui-loading-spinner\"\n    [style.height.px]=\"size\"\n    [style.width.px]=\"size\"\n    (click)=\"close.emit()\"\n  >\n    <div class=\"loader\">\n      <span cdkTrapFocus tabIndex=\"0\" [cdkTrapFocusAutoCapture]=\"hasTrappedFocus\" class=\"sr-only\">{{\n        'ngx-shared-content-is-loading' | mheTranslate | async\n      }}</span>\n      <svg class=\"circular\" viewBox=\"25 25 50 50\" focusable=\"false\" aria-hidden=\"true\">\n        <circle cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke=\"white\" stroke-width=\"2\"></circle>\n        <circle\n          class=\"path\"\n          cx=\"50\"\n          cy=\"50\"\n          r=\"20\"\n          fill=\"none\"\n          stroke-width=\"2\"\n          stroke-miterlimit=\"10\"\n        ></circle>\n      </svg>\n    </div>\n  </div>\n</ng-template>\n", styles: [".ahe-ui-loading-spinner{top:0;right:0;bottom:0;left:0;margin:auto;position:absolute}/*# sourceMappingURL=spinner.component.css.map */\n"] }]
    }], function () { return [{ type: i1.LiveAnnouncer }, { type: i2.TranslateService }]; }, { isOpen: [{
            type: Input
        }], hasTransparentOverlay: [{
            type: Input
        }], hasTrappedFocus: [{
            type: Input
        }], size: [{
            type: Input,
            args: ['size']
        }], useOverlay: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();
